import { useEffect } from "react";
import Card from "../Card";
import FunFact from "../FunFact";
import Hero from "../Hero";
import Div from "../Div";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import Cta from "../Cta";
import LogoList from "../LogoList";
import VideoModal from "../VideoModal";
import { pageTitle, imgUrl } from "../../helper";
import IconBox from "../IconBox";
// Hero Social Links
const heroSocialLinks = [
  {
    name: "Behance",
    links: "/",
  },
  {
    name: "Twitter",
    links: "/",
  },
];

// FunFact Data
const funfaceData = [
  {
    title: "Million Downloads",
    factNumber: "10",
  },
  {
    title: "Million Players",
    factNumber: "3.5",
  },
  {
    title: "Games",
    factNumber: "120",
  },
  {
    title: "Countries",
    factNumber: "7",
  },
];


export default function Home() {
  pageTitle("Home");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="Building Scalable <br/> Entertainment Platforms."
        subtitle="Dreamscript is a digital entertainment group focused on gaming, entertainment and telecom-powered IP platforms designed for emerging and global markets."
        btnText="Explore Our Platforms"
        btnLink="/contact"
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        // bgImageUrl="/images/hero_bg_1.jpg"
        bgImages={[
          "/images/banner-1.jpg",
          "/images/banner-2.jpg",
        ]}
      />
      {/* End Hero Section */}

      {/* Start About Section */}
      <Div className="cs-shape_wrap_4">
        <Div className="half-circle"></Div>
        <Div className="half-circle"></Div>
        <Spacing lg="150" md="80" />
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-5 col-xl-4">
              <SectionHeading
                title="Our Studio"
                subtitle={""}
                description="Dreamscript creates and operates digital entertainment platforms that combine strong IP, structured distribution and scalable monetization.
We focus on gaming, entertainment and engagement-driven ecosystems where community, competition and culture intersect.<br/><br/>
Our role is not advisory. We build, operate and scale the platforms we create."
                btnText="Learn More"
                btnLink=""
              />
              <Spacing lg="45" md="45" />
            </Div>
            <Div className="col-lg-7 offset-xl-1">
              <Div className="cs-half_screen">
                <VideoModal
                  videoSrc="https://www.youtube.com/watch?v=wiwsJixXwjA"
                  bgUrl="/images/video_bg.jpeg"
                  variant="cs-style1 cs-size1"
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End About Section */}

      {/* Start Operating Model */}
      <Spacing lg="145" md="80" />

      <Div className="cs-gradient_1">
        <div className="cs-height_150 cs-height_lg_80" />
        <Div className="container">
          <SectionHeading
            title="Our Operating Model"
            subtitle="WHAT WE DO"
            variant="cs-style1 text-center"
            description="Every Dreamscript platform is built on three structural layers."
          />
          <Spacing lg="90" md="45" />

          <Div className="row">
            <Div className="col-lg-4">
              <IconBox
                icon="/images/icons/idea.svg"
                title="Create"
                subtitle="We develop proprietary entertainment platforms grounded in strong intellectual property, user engagement and long-term scalability."
              />
              <Spacing lg="30" md="30" />
            </Div>
            <Div className="col-lg-4">
              <IconBox
                icon="/images/icons/distribute.svg"
                title="Distribute"
                subtitle="We integrate with telecommunications providers, brands and strategic partners to achieve rapid and structured market access."
              />
              <Spacing lg="30" md="30" />
            </Div>
            <Div className="col-lg-4">
              <IconBox
                icon="/images/icons/monetize.svg"
                title="Monetize"
                subtitle="We design subscription, rewards and advertising systems engineered for sustainable growth across diverse markets."
              />
              <Spacing lg="30" md="30" />
            </Div>
          </Div>
        </Div>
        <div className="cs-height_150 cs-height_lg_80" />
      </Div>
      {/* End Operating Model */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Our Platforms"
                subtitle=""
                description="Powering digital experiences that bring people together through play, sound, and shared interaction."
                btnText=""
                btnLink=""
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title=""
                    link="/portfolio"
                    src="/images/vibra.png"
                    alt="portfolio"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile">
                  <Card
                    title=""
                    link="/portfolio"
                    src="/images/amusement.jpg"
                    alt="portfolio"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title=""
                    link="/portfolio"
                    src="/images/exscape.jpg"
                    alt="portfolio"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title=""
                    link="/portfolio"
                    src="/images/arena-img.png"
                    alt="portfolio"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="Our Scale"
          subtitle="Across our platforms, Dreamscript operates at a meaningful scale across multiple markets."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Video Block Section */}
      <Spacing lg="200" md="70" />
      <Div className="container">
        <h3 className="cs-font_45 cs-m0 text-center cs-line_height_4">
          Our platforms are built for distribution. We combine strong
          intellectual property with structured telecom integration to achieve
          scale efficiently and sustainably. We focus on long-term ecosystem
          growth, not short-term acquisition spikes.
        </h3>
        <Spacing lg="100" md="25" />
        <Div className="col-lg-12">
          <img
            src={imgUrl("/images/studio.jpg")}
            alt="About"
            className="w-100 cs-radius_15"
          />
        </Div>
      </Div>
      {/* End Video Block Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <Spacing lg="100" md="25" />
        <h2 className="cs-font_5 cs-m0 text-center cs-line_height_4">
          Our Partners
        </h2>
        <Spacing lg="50" md="80" />
        <LogoList limit={6} perRow={6} size={250} categories={["telco", "brand","other"]} />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let’s Build the Next Entertainment<br/>Platforms Together."
          description="Whether you are a strategic partner, investor or distribution collaborator, we are always open to structured conversations."
          btnText="Contact Us"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
